module.exports = __webpack_public_path__ + "img/abstract-product.7c17c992.svg";